module.exports = __webpack_public_path__ + "img/Legenden.a014917d.png";